import axios from "axios";
//import router from '../router';
import swal from "sweetalert2";
import store from "../store";
import router from "./../router";

let baseUrl = "";

baseUrl =
    document.location.protocol + "//" + document.location.hostname + "/api";

const api = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    proxyHeaders: false,
    json: null,
    headers: {
        "content-type": "application/json"
    },
});

api.interceptors.request.use(
    function (config) {
        if (config.method === "get") {
            config.data = "";
            store.commit("loading/status", true);
        }

        if (config.method === "post" || config.method === "put") {
            store.commit("loading/statusBtn", true);
        }

        const token = sessionStorage.getItem("token");
        config.headers = { Authorization: token ? `Bearer ${token}` : "" };

        let source = axios.CancelToken.source();

        // Set cancel token on this request
        config.cancelToken = source.token;

        // Add to vuex to make cancellation available from anywhere
        store.commit("api/ADD_CANCEL_TOKEN", source);

        return config;
    },
    error => {
        store.commit("loading/status", false);
        store.commit("loading/statusBtn", false);

        console.log("error request", error);

        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    function (response) {
        //  console.log("response", response);
        store.commit("loading/status", false);
        store.commit("loading/statusBtn", false);

        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        //   console.log("response ", response);

        if (response.data.alert) {
            new swal(response.data.alert);
        }

        if (response.data.info) {
            new swal({ icon: "info", title: response.data.info });
        }

        if (response.data.warning) {
            new swal({ icon: "warning", title: response.data.warning });
        }

        if (response.data.success) {
            new swal({
                icon: "success",
                title: response.data.success,
                timer: 1500
            });
        }

        if (response.data.redirect) {
            location.replace(response.data.redirect);
            window.setTimeout(function () {
                window.location.href = response.data.redirect;
                if (window.location.hash) {
                    window.location.reload();
                }
            }, 1000);
        }

        if (
            response.request.responseURL &&
            response.request.responseURL.includes("/login")
        ) {
            new swal({ icon: "warning", title: "Sessão expirada!" });

            window.location.href = "/login";
        }

        return response;
    },
    function (error) {
        store.commit("loading/status", false);
        store.commit("loading/statusBtn", false);
        //  console.log("error", error);

        if (error.response && error.response.status === 500) {
            new swal({
                icon: "error",
                title: "Oops...",
                text: "Ocorreu um erro inesperado",
                footer:
                    "Tente novamente mais tarde. Se o problema persistir entre em contato com o suporte."
            });
        }

        if (error.response && error.response.status === 422) {
            let errors = error.response.data;

            if (Object.keys(errors).length > 0) {
                // console.log("400 erros ojbect lenght");

                // $("html, body").animate({ scrollTop: 0 }, 600);

                // $(document).find(".modal-dialog").animate({ scrollTop: 0 }, 600);

                $(document)
                    .find(".is-invalid")
                    .removeClass("is-invalid");
                $(document)
                    .find(".error")
                    .removeClass("error");
                // $(".errors").show();
                // $(".ul-erros").html('');

                let string_erros = "";

                for (var key in errors) {
                    $(document)
                        .find(`input[name="${key}"]`)
                        .addClass("is-invalid");
                    $(document)
                        .find(`select[name="${key}"]`)
                        .addClass("is-invalid");
                    $(document)
                        .find(`input[name="${key}"]`)
                        .parent(".selection")
                        .addClass("error");
                    $(document)
                        .find(`textarea[name="${key}"]`)
                        .addClass("is-invalid");

                    string_erros += errors[key][0] + "<br>";
                }


                if (error.response.data && error.response.data.success) {
                    new swal({
                        icon: "warning",
                        title: error.response.data.warning,

                    });
                } else {
                    new swal({
                        icon: "warning",
                        title: "Atenção! verifique os campo(s) abaixo:",
                        html: string_erros
                    });
                }


            }
        }

        if (error.response && error.response.status === 400) {
            const errors = error.response.data.errors;

            let string_erros = "";

            if (errors && Object.keys(errors).length > 0) {
                // console.log("400 erros ojbect lenght");

                // $("html, body").animate({ scrollTop: 0 }, 600);

                // $(document).find(".modal-dialog").animate({ scrollTop: 0 }, 600);

                $(document)
                    .find(".is-invalid")
                    .removeClass("is-invalid");
                $(document)
                    .find(".error")
                    .removeClass("error");
                // $(".errors").show();
                // $(".ul-erros").html('');



                for (var key in errors) {
                    $(document)
                        .find(`input[name="${key}"]`)
                        .addClass("is-invalid");
                    $(document)
                        .find(`select[name="${key}"]`)
                        .addClass("is-invalid");
                    $(document)
                        .find(`input[name="${key}"]`)
                        .parent(".selection")
                        .addClass("error");
                    $(document)
                        .find(`textarea[name="${key}"]`)
                        .addClass("is-invalid");

                    string_erros += errors[key][0] + "<br>";
                }




            }

            if (error.response.data.warning) {
                new swal({
                    icon: "warning",
                    title: error.response.data.warning,

                });
            } else {
                new swal({
                    icon: "warning",
                    title: "Atenção! verifique os campo(s) abaixo:",
                    html: string_erros
                });
            }
        }

        if (error.response && error.response.status === 402) {
            router.push(error.response.data.redirect);
        }

        if (error.response && error.response.status === 403) {
            new swal({ icon: "danger", title: "Acesso negado!", text: "Solicite a liberação de acesso com o seu gestor." });
            router.push('/');
        }

        if (
            (error.response && error.response.status === 401) ||
            (error.response && error.response.status === 302)
        ) {
            new swal({ icon: "warning", title: "Sessão expirada!" });

            window.location.href = "/login";
        }

        if (error.response && error.response.status === 503) {
            window.location.href = "/";
        }

        if (error.response && error.response.status === 404) {
            new swal({ icon: "warning", title: "Página não encontrada!" });
        }

        if (error === "Network Error") {
            new swal(
                "Falha ao conectar, estaremos de volta o mais breve possivel!"
            );
        }

        // router.push("/login")

        // console.log({ ...error })
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);

export default api;
